export const useSxStyles = () => {
  return {
    approveStep: { display: 'flex', justifyContent: 'center' },
  };
};
